// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".alerts[data-v-ae7b767a] {\n  position: fixed;\n  width: 50%;\n  left: 52%;\n  margin-left: -25%;\n  z-index: 1000;\n}\n.alerts[data-v-ae7b767a] .v-alert {\n  width: 90%;\n}\n@media (max-width: 599px) {\n.alerts[data-v-ae7b767a] {\n    width: 100%;\n    left: 0;\n    margin-left: 0;\n}\n.alerts[data-v-ae7b767a] .v-alert {\n    width: 100%;\n}\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
